"use client";

import { useUserContext } from "@contexts/user-context";
import { setupNewRelicLogging, waitForNewRelic } from "@utils/client/newrelic";
import React, { ReactNode, use, useEffect } from "react";
import Cookies from "js-cookie";

type MonitoringWrapperProps = {
  children: ReactNode;
};

const MonitoringWrapper: React.FC<MonitoringWrapperProps> = ({ children }) => {
  const { userData, isLoggedIn } = useUserContext();
  useEffect(() => {
    setupNewRelicLogging();
  }, []);
  useEffect(() => {
    waitForNewRelic()
      .then((nr) => {
        nr.setUserId(userData?.ekey || "tr-" + Cookies.get("trackerid"));
      })
      .catch((err) => {
        console.warn(err.message);
      });
  }, [isLoggedIn]);

  return <>{children}</>;
};

export default MonitoringWrapper;
